import {
  useTranslation as useI18nTranslation,
  UseTranslationResponse,
} from 'react-i18next'

export function useTranslation(): UseTranslationResponse<'remote'> {
  return useI18nTranslation('remote')
}
